// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"480":"df902cf7","541":"df902cf7"}[chunkId] + ".chunk.css";
};